const { Fragment } = window.React;

const Tabs = (props) => {
  return (
    <Fragment>
      <div className="container show-desktop">
        <div className={`row tabs ${props.rstCode.toLowerCase()}`}>
          <div className={`xs tab nest ${props.tab === 'nest' ? 'selected' : ''}`} onClick={() => props.tabClick('nest')}>
            <span className="icon-logo-together-nest"/>
          </div>
          {
            props.rstCode !== 'BBO' && <div className={`xs tab ${props.tab === 'butler' ? 'selected' : ''}`} onClick={() => props.tabClick('butler')}>
              <div className="tab-content"> butler <span className="show">level</span></div>
            </div>
          }
          <div className={`xs tab ${props.tab === 'concierge' ? 'selected' : ''}`} onClick={() => props.tabClick('concierge')}>
            <div className="tab-content"> concierge <span className="show">level</span></div></div>
          <div className={`xs tab ${props.tab === 'luxury' ? 'selected' : ''}`} onClick={() => props.tabClick('luxury')}>
            <div className="tab-content"> luxury <span className="show">level</span></div>
          </div>
          <div className={`xs tab ${props.tab === 'viewAll' ? 'selected' : ''}`} onClick={() => props.tabClick('viewAll')}>
            <div className="tab-content"> view <span className="show">all</span></div>
          </div>
        </div>
      </div>
      <div className="tabs show-mobile">
        <div className="xs-12 control-wrapper custom-ddl">
          <select defaultValue="viewAll" onChange={(e) => props.tabClick(e.target.value)}>
            <option value="nest">Together Nest Suites</option>
            <option value="butler">Butler Level</option>
            <option value="concierge">Concierge Level</option>
            <option value="luxury">Luxury Level</option>
            <option value="viewAll">View All</option>
          </select>
        </div>
      </div>
    </Fragment>
  );
};

export default Tabs;
